// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2NLbd","active":"_1DQIH","small":"_2Qk-5","normal":"_2NByG","large":"_3fJ6O","title":"_1WtCw","body":"_2nekn","navigation":"_3aGkD","button":"_3x3mJ","close":"_2XvUi"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Modal/Modal.css
// module id = 494
// module chunks = 0